import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { VigenciaValor } from '../../components'
import * as vigenciaValorActionCreators from '../../redux/modules/vigenciaValor'
import * as bandeiraActionCreators from '../../redux/modules/bandeira'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'
import moment from 'moment'

class VigenciaValorContainer extends Component {

  static propTypes = {
    history: PropTypes.object,
    multipleVigenciaValor: PropTypes.object,
    fetchMultipleVigenciaValor: PropTypes.func,
    multipleBandeira: PropTypes.object,
    fetchMultipleBandeira: PropTypes.func,
    destroyVigenciaValor: PropTypes.func,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    isLoading: PropTypes.bool,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string
  }

  async componentDidMount () {
    await this.props.fetchMultipleVigenciaValor()
    await this.props.fetchMultipleBandeira()
  }

  handleRedirectToNew = () => {
    this.props.history.push('/gestao_bandeiras/valores/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/gestao_bandeiras/valores/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyVigenciaValor(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('vigenciaValor', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('vigenciaValor', name, value)

  handleExportToCSV = () => {
    const multipleVigenciaValor = this.props.multipleVigenciaValor
    arrayToCSV(
      multipleVigenciaValor.toList().toJSON(),
      'vigenciaValor',
      [
        'id',
        {
          label: 'Início da Vigência',
          value: row => moment(row.starts_at, 'YYYY-MM-DD').format('DD/MM/YYYY')
        },
        {
          label: 'Bandeira',
          value: 'valores_bandeiras.bandeira_nome' },
        {
          label: 'Valor',
          value: 'valores_bandeiras.valor' }
      ],
      [ 'valores_bandeiras' ]
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <VigenciaValor
        onRedirectToNew={this.handleRedirectToNew}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        multipleVigenciaValor={this.props.multipleVigenciaValor}
        multipleBandeira={this.props.multipleBandeira}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading}
      />
    )
  }
}

function mapStateToProps ({vigenciaValor, bandeira, status, sort, filter}) {
  const sortColumn = sort.getIn(['vigenciaValor', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['vigenciaValor', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['vigenciaValor', 'filterText']) || ''

  let map = filterMap(vigenciaValor, ['starts_at', 'Valo.nome'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleVigenciaValor: map,
    multipleBandeira: bandeira,
    error: status.getIn(['vigenciaValor', 'error']),
    isLoading: status.getIn(['vigenciaValor', 'isLoading']),
    sortColumn,
    sortDirection,
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...vigenciaValorActionCreators,
    ...bandeiraActionCreators,
    ...flashMessageAcionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VigenciaValorContainer))
